import Apeiron_logo from '../asserts/icons/bot_logo.svg'
import { BOT_USER_ID } from './constant'

const BOT_USER_AVATAR = Apeiron_logo

export const getUserAvatar = (username, userAvatars = []) => {
  if (!username) return null

  if (username === BOT_USER_ID) {
    return BOT_USER_AVATAR
  }

  const userAvatar = userAvatars.find(user => user.username === username)
  if (userAvatar && userAvatar.avatar) {
    return userAvatar.avatar
  }

  return username.charAt(0).toUpperCase()
}

export const hasAvatarImage = (username, userAvatars = []) => {
  if (!username) return false

  if (username === BOT_USER_ID) {
    return true
  }

  const userAvatar = userAvatars.find(user => user.username === username)
  return userAvatar && userAvatar.avatar !== null
}
